import React from "react"
import { Link, graphql } from "gatsby"

import Bio from "../components/bio"
import Layout from "../components/layout"
import SEO from "../components/seo"
import MeinImage from "../components/MeinImage"
class BlogIndex extends React.Component {
  render() {
    const { data } = this.props
    const siteTitle = data.site.siteMetadata.title
    
    return (
      <Layout location={this.props.location} title={siteTitle}>
      
        <SEO
          title="Zimmervermietung in Bacharach"
          keywords={[`Zimmervermietung`,`Vermietung`,`Bacharach`, `Welterbe Mittelrheintal`, `Frackgalerie`, `Urlaub`]}
        />
       
        <div className="container">
        <Bio />
        <div className="start">
            <Link to="/wohnen"><h2> &rarr; Übernachten in Bacharach</h2></Link>    
            <MeinImage  daten={this.props.data.w2.childImageSharp.fluid} alter="Mein Zimmerangebot"/>
        </div>
        <div className="start">
            <Link to="/herrliche-Landschaft"><h2> &rarr; Herrliche Landschaft</h2></Link>   
            <MeinImage   daten={this.props.data.w3.childImageSharp.fluid} alter="Der Rhein und Umgebung"/>
        </div>
        <div className="start">
            <Link to="/kultur"><h2> &rarr; Kultur</h2></Link>   
            <MeinImage   daten={this.props.data.w1.childImageSharp.fluid} alter="Kultur am Rhein"/>
        </div>
        <div className="start">
            <Link to="/herrliche-Landschaft"><h2> &rarr; Ideen für Ihren Urlaub</h2></Link>   
            <MeinImage daten={this.props.data.rhein.childImageSharp.fluid} alter="Erlebnis Rheinreise"/>
        </div>
        </div>
            </Layout>
    )
  }
}

export default BlogIndex


export const pageQuery = graphql`
  query {
    site {
      siteMetadata {
        title
      }
    }
    rhein: file(absolutePath: { regex: "/schiff-vor-ehrenfels.jpg/" }) {
      childImageSharp {
        fluid {
          ...GatsbyImageSharpFluid
        }
      }
    }
    w1: file(absolutePath: { regex: "/liebfrauen-illuminiert.jpg/" }) {
      childImageSharp {
        fluid {
          ...GatsbyImageSharpFluid
        }
      }
    } 
    w2: file(absolutePath: { regex: "/zimmer.jpg/" }) {
      childImageSharp {
        fluid {
          ...GatsbyImageSharpFluid
        }
      }
    } 
w3: file(absolutePath: { regex: "/eselspfadblick/" }) {
      childImageSharp {
        fluid {
          ...GatsbyImageSharpFluid
        }
      }
    } 
  }
`
